import { api } from '../api/client'
import type { NewShift } from '../api/generated/NewShift'
import type { Shift } from '../api/generated/Shift'
import type { ShiftFields } from '../api/generated/ShiftFields'
import type { ShiftSeries } from '../api/generated/ShiftSeries'
import type { ShiftSplit } from '../api/generated/ShiftSplit'
import { sortShifts } from './fill'
import { formatRange } from './time'

type SetShifts = (update: (current: Shift[] | undefined) => Shift[]) => void

/** The organizer's shift writes, each applied to the list `setShifts` holds, in the API's order. */
export function shiftWrites(slug: string, setShifts: SetShifts) {
  const path = `/events/${slug}/shifts`
  const replace = (removedId: string | undefined, added: Shift[]) =>
    setShifts((current) =>
      sortShifts([...(current ?? []).filter((shift) => shift.id !== removedId), ...added]),
    )
  return {
    create: async (shift: NewShift) => replace(undefined, [await api.post<Shift>(path, shift)]),
    createSeries: async (series: ShiftSeries) =>
      replace(undefined, await api.post<Shift[]>(`${path}/series`, series)),
    update: async (shift: Shift, fields: ShiftFields) =>
      replace(shift.id, [await api.patch<Shift>(`${path}/${shift.id}`, fields)]),
    split: async (shift: Shift, split: ShiftSplit) =>
      replace(shift.id, await api.post<Shift[]>(`${path}/${shift.id}/split`, split)),
    remove: async (shift: Shift) => {
      await api.delete(`${path}/${shift.id}`)
      replace(shift.id, [])
    },
  }
}

export function confirmRemoval(shift: Shift): boolean {
  return confirm(`Supprimer le créneau ${formatRange(shift.starts_at, shift.ends_at)} ?`)
}
